// extracted by mini-css-extract-plugin
export default {"icon":"popularity-rank_icon__1C3NA"};